import React from "react";
import Layout from "./shared/Layout";
import classes from "./assets/css/Skill.module.css";

const Skill = () => {
  return (
    <Layout>
      <div className={classes.skill_container}>
        <h2 className="text-center dark-text">Web Developer</h2>
        <p className="text-center" style={{ color: "#142cff" }}>
          Joshua Moses
        </p>

        <div className={classes.skills}>
          <div className={classes.general_skills}>
            <h3 className="dark-text">Frontend</h3>
            <div className={`mt-2 mb-4 ${classes.skill}`}>
              <span
                className={classes.frontend}
                style={{ width: "90%" }}
              ></span>
            </div>

            <h3 className="dark-text">Backend</h3>
            <div className={`mt-2 mb-4 ${classes.skill}`}>
              <span className={classes.backend} style={{ width: "45%" }}></span>
            </div>
          </div>

          <div className={classes.skill_list}>
            <ul>
              <li className="dark-text">HTML</li>
              <li className="dark-text">CSS</li>
              <li className="dark-text">CSS Modules</li>
              <li className="dark-text">Styled Components</li>
              <li className="dark-text">Bootstrap</li>
              <li className="dark-text">JavaScript</li>
              <li className="dark-text">ReactJs</li>
              <li className="dark-text">NextJs</li>
              <li className="dark-text">NodeJs</li>
              <li className="dark-text">ExpressJs</li>
              <li className="dark-text">Solidity</li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Skill;
